import { apiErrorFraResponse, customFetch } from "./customFetch";

/**
 * Fil-download gennem customFetch (CSRF-header + session-cookie følger med).
 * Blob + midlertidigt anker — ingen navigation, ingen ny fane.
 */
export async function downloadFil(path: string, filnavn: string): Promise<void> {
  const res = await customFetch(path);
  if (!res.ok) throw await apiErrorFraResponse(res);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  try {
    const anker = document.createElement("a");
    anker.href = url;
    anker.download = filnavn;
    document.body.appendChild(anker);
    anker.click();
    anker.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}
